import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import userModule from "./modules/user";
Vue.use(Vuex);
const dataState = createPersistedState({
  key: "mcn-state-management",
  paths: ["user.savedData", "user.salePages", "user.data.userPixels", "user.language", "user.drafts"]
});
export default new Vuex.Store({
  modules: {
    user: userModule
  },
  plugins: [dataState]
});